export default __webpack_public_path__ + "static/media/banner5.ea653577.png";